/**
 * Created by USER on 18/7/26.
 */
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {Tabs} from 'antd';
import ImgList from '../images/img';
import {changeBarState} from '../redux/actions/headerbar_action';
import SingleMembers from '../component/single_members';

const {TabPane} = Tabs;


const membersData = [
  {
    num: '0', img: ImgList.img.fd, name: '傅栋', notice: 'CEO'
  },
  {
    num: '1', img: ImgList.img.lwx, name: '刘万星', notice: 'CTO'
  },
  {
    num: '13', img: ImgList.img.syd, name: '邵俞达', notice: 'COO'
  },
  {
    num: '6', img: ImgList.img.zjh, name: '周建辉', notice: '高级区块链工程师'
  },
  {
    num: '12', img: ImgList.img.hzq, name: '黄治群', notice: '后端工程师'
  },
  {
    num: '8', img: ImgList.img.lf, name: '李帆', notice: '前端工程师'
  },
  {
    num: '3', img: ImgList.img.lcb, name: '刘成宝', notice: '前端工程师'
  },
  {
    num: '9', img: ImgList.img.qxb, name: '齐兴邦', notice: '交互设计师'
  },
  {
    num: '5', img: ImgList.img.you, name: 'You', notice: ''
  }
];

class Team extends Component {
  constructor(props) {
    super(props);
    this.state = {
      state: 'LUBANSO_team',
      isRender: false
    };
  }

  componentWillMount() {
    this.props.dispatch(changeBarState('team'));
  }
  componentDidMount() {
    this.setState({
      state: this.props.location.state
    });
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.state !== this.props.location.state) {
      this.setState({
        isRender: false
      });
      setTimeout(() => {
        this.setState({
          isRender: true
        });
      }, 500);
    } else {
      this.setState({
        isRender: true
      });
    }
  }

  render() {
    const {t} = this.props;
    const {isRender} = this.state;
    const {state} = this.props.location;
    return (
    isRender ?
      <div className="team">
        <Tabs
          defaultActiveKey={!state ? 'LUBANSO_team' : state}
          tabPosition={'top'}
          style={{ minHeight: 400 }}
        >
          <TabPane tab={t('team')} key="LUBANSO_team">
            <div className="team_title">
              <div className="team_title_name">{t('team')}</div>
              <div className="team_title_notice">{t('team_notice')}</div>
              <div className="team_title_divider" />
              <p className="team_title_details">
                {t('team_details')}
              </p>
              <p className="team_title_details team_title_details_last">
                {t('team_details1')}
              </p>
            </div>
            <div className="team_list">
              {
                membersData.map(item =>
                  <SingleMembers key={item.num} img={item.img} name={item.name} notice={item.notice} />)
              }
            </div>
          </TabPane>
          <TabPane tab={t('laboratory')} key="LUBANSO_laboratory">
            <div className="LUBANSO_laboratory_img">
              <img src={ImgList.img.laboratory} alt="LUBANSO"/>
            </div>
            <div className="team_title laboratory">
              <div className="team_title_name team_title_name_laboratory">{t('laboratory_notice')}</div>
              <p className="team_title_details team_title_details_last">
                {t('laboratory_details')}
              </p>
              <p className="team_title_details team_title_details_last">
                {t('laboratory_details1')}。
              </p>
              <p className="team_title_details team_title_details_last">
                {t('laboratory_details2')}
              </p>
              <p className="team_title_details team_title_details_last">
                {t('laboratory_details3')}
              </p>
              <p className="team_title_details team_title_details_last">
                {t('laboratory_details4')}
              </p>
            </div>
          </TabPane>
        </Tabs>
      </div> : false
    );
  }
}

function select(state) {
  return {
    appBarReducer: state.appBarReducer
  };
}

const TeamConnected = connect(select)(Team);

export default translate('translations')(TeamConnected);
